// 危险操作按钮 — 红色填充按钮
// Fluent UI v9 的 Button 无 danger 变体,用原生 button + Griffel 实现,
// 使用 colorStatusDanger 系列 token 保证主题一致与可靠性(避免覆盖内部样式的不确定性)
import { type ReactNode } from 'react';
import { makeStyles, tokens, Spinner } from '@fluentui/react-components';

const useStyles = makeStyles({
  root: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '6px',
    flexShrink: 0,
    whiteSpace: 'nowrap',
    boxSizing: 'border-box',
    height: '32px',
    padding: '0 12px',
    borderRadius: tokens.borderRadiusMedium,
    border: '1px solid transparent',
    backgroundColor: tokens.colorStatusDangerBackground3,
    color: tokens.colorStatusDangerForegroundInverted,
    fontFamily: tokens.fontFamilyBase,
    fontSize: tokens.fontSizeBase300,
    fontWeight: tokens.fontWeightSemibold,
    lineHeight: 1,
    cursor: 'pointer',
    userSelect: 'none',
    transitionProperty: 'background-color',
    transitionDuration: '0.1s',
    ':hover': { backgroundColor: tokens.colorStatusDangerBackground3Hover },
    ':active': { backgroundColor: tokens.colorStatusDangerBackground3Pressed },
    ':disabled': {
      backgroundColor: tokens.colorNeutralBackgroundDisabled,
      color: tokens.colorNeutralForegroundDisabled,
      cursor: 'not-allowed',
    },
  },
});

interface DangerButtonProps {
  children?: ReactNode;
  icon?: ReactNode;
  disabled?: boolean;
  loading?: boolean;
  onClick?: () => void;
  type?: 'button' | 'submit';
}

export function DangerButton({
  children,
  icon,
  disabled,
  loading,
  onClick,
  type = 'button',
}: DangerButtonProps) {
  const styles = useStyles();
  return (
    <button
      type={type}
      className={styles.root}
      disabled={disabled || loading}
      onClick={onClick}
    >
      {loading ? <Spinner size="tiny" /> : icon}
      {children}
    </button>
  );
}
